import React, { useState, useRef } from "react";
import "../Contracting/Contracting.css";
import logoSrc from "../img/logo.png";
import ContactForm from "../ContactForm"; // Make sure this component has the `openForm` method.

function ChamberFormular() {
  const contactFormRef = useRef(); // Reference for controlling the contact form

  // Function to open the contact form
  const handleOpenContactForm = () => {
    if (contactFormRef.current) {
      contactFormRef.current.openForm(); // Ensure the `ContactForm` has this method.
    }
  };

  const [formData, setFormData] = useState({
    fullName: "",
    organizationName: "",
    email: "",
    phone: "",
    countryRegion: "",
    languagesSpoken: "",
    experience: "",
    brandRepresentation: "",
    goodFitReason: "",
    socialLinks: "",
    supportingDocuments: null,
    questionsComments: "",
  });

  const [snackbar, setSnackbar] = useState({
    message: "",
    show: false,
    type: "success",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = (e) => {
    setFormData({ ...formData, supportingDocuments: e.target.files[0] });
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    const formDataToSubmit = new FormData();
    formDataToSubmit.append("fullName", formData.fullName);
    formDataToSubmit.append("email", formData.email);
    formDataToSubmit.append("organizationName", formData.organizationName);
    formDataToSubmit.append("phone", formData.phone);
    formDataToSubmit.append("countryRegion", formData.countryRegion);
    formDataToSubmit.append("languagesSpoken", formData.languagesSpoken);
    formDataToSubmit.append("experience", formData.experience);
    formDataToSubmit.append(
      "brandRepresentation",
      formData.brandRepresentation
    );
    formDataToSubmit.append("goodFitReason", formData.goodFitReason);
    formDataToSubmit.append("socialLinks", formData.socialLinks);
    formDataToSubmit.append("questionsComments", formData.questionsComments);

    if (formData.supportingDocuments) {
      formDataToSubmit.append(
        "supportingDocuments",
        formData.supportingDocuments
      );
    }

    fetch("https://apiqms.shigjeta.com/api/forms/chamber/submit", {
      method: "POST",
      body: formDataToSubmit,
    })
      .then((response) => response.json()) // Parse the response as JSON
      .then((data) => {
        console.log("Form submitted successfully:", data);
        if (data.success) {
          setSnackbar({
            message: "Form submitted successfully!",
            show: true,
            type: "success",
          });
        } else {
          setSnackbar({
            message: "Error: " + data.message,
            show: true,
            type: "error",
          });
        }
      })
      .catch((error) => {
        console.error("Error submitting form:", error);
        setSnackbar({
          message: "Error submitting form. Please try again later.",
          show: true,
          type: "error",
        });
      });
  };

  // Snackbar styling
  const snackbarStyle = {
    position: "fixed",
    top: "20px", // Move it to the top
    left: "50%", // Center horizontally
    transform: "translateX(-50%)", // Adjust to perfectly center
    backgroundColor: snackbar.type === "success" ? "#16a085" : "#e74c3c", // Green for success, red for error
    color: "white",
    padding: "15px 30px",
    borderRadius: "8px",
    fontSize: "16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
    zIndex: 1001,
    animation: "fadeIn 0.5s ease-out",
  };

  const dismissButtonStyle = {
    background: "none",
    border: "none",
    color: "white",
    fontSize: "16px",
    cursor: "none",
    fontWeight: "bold",
    marginLeft: "15px", // Adds a gap between the text and the button
  };

  // Close snackbar after 5 seconds
  setTimeout(() => {
    if (snackbar.show) {
      setSnackbar({ ...snackbar, show: false });
    }
  }, 5000);

  return (
    <>
      <div className="banner-logo" id="sectionBanner1">
        {logoSrc && <img src={logoSrc} alt="Formular Logo" />}
      </div>

      <section className="banner-section" id="sectionBanner">
        <div className="banner-container">
          <div className="banner-text">
            <h1 className="banner-title">your gateway to growth and success</h1>
            <p className="banner-description">
              Join us as an ambassador and represent our brand in your region.
            </p>
            <a
              onClick={handleOpenContactForm} // Open the form on button click
              className="banner-button"
            >
              Start Now
            </a>
          </div>
          <div className="shop-hero-background"></div>
        </div>
      </section>

      <div className="img-background">
        <img
          className="img"
          id="banner1-video"
          src="/img/Sales Thumbnail.png" // This should be correct if the video is in the public folder
          autoPlay
          muted
          loop
          playsInline
          onError={(e) => console.error("Error loading video:", e)} // Error logging for debugging
          alt="img"
        />
      </div>

      <h3 className="textForm">Chamber Ambassador Application Form</h3>

      {/* Form Section */}
      <section className="contract-form-container">
        <form onSubmit={handleSubmit} className="contract-form">
          <div className="divFlexField">
            <div className="form-group">
              <label>Full Name</label>
              <input
                type="text"
                id="fullName"
                name="fullName"
                value={formData.fullName}
                onChange={handleChange}
                placeholder="Enter your full name"
                required
              />
            </div>
            <div className="form-group">
              <label>Organization Name (Optional)</label>
              <input
                type="text"
                id="organizationName"
                name="organizationName"
                value={formData.organizationName}
                onChange={handleChange}
                placeholder="Enter your organization name (optional)"
              />
            </div>
          </div>

          <div className="divFlexField">
            <div className="form-group">
              <label>Email</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Enter your email"
                required
              />
            </div>
            <div className="form-group">
              <label>Phone Number</label>
              <input
                type="tel"
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder="Enter your phone number"
              />
            </div>
          </div>

          <div className="divFlexField">
            <div className="form-group">
              <label>Country/Region</label>
              <input
                type="text"
                id="countryRegion"
                name="countryRegion"
                value={formData.countryRegion}
                onChange={handleChange}
                placeholder="Country/Region"
                required
              />
            </div>
            <div className="form-group">
              <label>Languages Spoken</label>
              <input
                type="text"
                id="languagesSpoken"
                name="languagesSpoken"
                value={formData.languagesSpoken}
                onChange={handleChange}
                placeholder="Languages you speak"
                required
              />
            </div>
          </div>

          <div className="divFlexField">
            <div className="form-group">
              <label>Experience in Networking or Representation</label>
              <select
                id="experience"
                name="experience"
                value={formData.experience}
                onChange={handleChange}
              >
                <option value="None">None</option>
                <option value="1-3 years">1-3 years</option>
                <option value="3-5 years">3-5 years</option>
                <option value="5+ years">5+ years</option>
              </select>
            </div>
          </div>

          <div className="form-group">
            <label>How Can You Represent Our Brand?</label>
            <textarea
              id="brandRepresentation"
              name="brandRepresentation"
              value={formData.brandRepresentation}
              onChange={handleChange}
              placeholder="Explain how you can represent our brand"
              required
            />
          </div>

          <div className="form-group">
            <label>What Makes You a Good Fit as an Ambassador?</label>
            <textarea
              id="goodFitReason"
              name="goodFitReason"
              value={formData.goodFitReason}
              onChange={handleChange}
              placeholder="Explain why you're a good fit"
              required
            />
          </div>

          <div className="form-group">
            <label>Social Media or Professional Profile Links</label>
            <input
              type="text"
              id="socialLinks"
              name="socialLinks"
              value={formData.socialLinks}
              onChange={handleChange}
              placeholder="Enter links to your social/professional profiles"
            />
          </div>

          <div className="form-group">
            <label>Attach Supporting Documents (Optional)</label>
            <input
              type="file"
              name="supportingDocuments"
              accept="image/*,.pdf,.docx"
              onChange={handleFileChange}
            />
          </div>

          <div className="form-group">
            <label>Questions/Comments</label>
            <textarea
              id="questionsComments"
              name="questionsComments"
              value={formData.questionsComments}
              onChange={handleChange}
              placeholder="Any questions or additional comments?"
            />
          </div>

          <button type="submit" className="submit-button">
            Submit Application
          </button>
        </form>
      </section>

      {/* Snackbar display */}
      {snackbar.show && (
        <div style={snackbarStyle}>
          <span>{snackbar.message}</span>
          <button
            onClick={() => setSnackbar({ ...snackbar, show: false })}
            style={dismissButtonStyle}
          >
            X
          </button>
        </div>
      )}

      <ContactForm ref={contactFormRef} />
    </>
  );
}

export default ChamberFormular;
